// aws-exports.js
const awsExports = {
  Auth: {
    Cognito: {
      region: 'us-east-1',
      userPoolId: 'us-east-1_nUpBaQ1Xp',
      userPoolClientId: '2f4use63dc36eraa7em52q73ah',
      loginWith: {
        username: true,
        email: true,
        oauth: {
          // keep the same Hosted UI domain (no protocol)
          domain: 'us-east-1nupbaq1xp.auth.us-east-1.amazoncognito.com',
          scopes: ['openid', 'email', 'phone', 'profile'],
          redirectSignIn: [
            'http://localhost:3000/',
            'https://dnh6qh3zeqkj3.cloudfront.net/',   // ← added
            'https://www.innovativetruckingllc.net/'
          ],
          redirectSignOut: [
            'http://localhost:3000/',
            'https://dnh6qh3zeqkj3.cloudfront.net/',   // ← added
            'https://www.innovativetruckingllc.net/'
          ],
          responseType: 'code'
        }
      }
    }
  },
  Storage: {
    S3: {
      bucket: 'it-webapp-imagestorage',
      region: 'us-east-1'
    }
  }
};

export default awsExports;
